import apiClient from '../../../services/apiClient';
import { appendDateToFilename } from '../../../utils/dateUtils';
import { exportData } from '../../../utils/exportData';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';

const ApiClient = async (method, route, data = {}) => {
  try {
    let response;
    if (method === 'post') {
      response = await apiClient.post(route, data);
    } else if (method === 'get') {
      response = await apiClient.get(route, { params: data });
    } else if (method === 'put') {
      response = await apiClient.put(route, data);
    }
    console.log('data', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error;
  }
};
export const importProducts = async (formData) => {
  try {
    const response = await apiClient.post('/products/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('data', response);

    showSuccessToast(response?.data?.message || '');
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error.data;
  }
};

export const fetchInventory = async (query) => {
  return await ApiClient('get', '/inventory', query);
};
export const fetchProcessCategories = async () => {
  return await ApiClient('get', '/master/process-category', { per_page: 1000 });
};
export const fetchProductCategories = async () => {
  return await ApiClient('get', '/master/product-category', { per_page: 1000 });
};
export const fetchOrigins = async () => {
  return await ApiClient('get', '/master/origin', { per_page: 1000 });
};
export const addInventory = async (data) => {
  return await ApiClient('post', '/inventory', data);
};
export const searchProducts = async (query) => {
  return await ApiClient('get', '/products/search-product', query);
};
export const downloadSample = async (fileName) => {
  const route = '/inventory/sample';
  try {
    fileName = appendDateToFilename(fileName);
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    const token = localStorage.getItem('authToken');
    const response = await fetch(apiUrl + route, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    });
    // console.log('response', JSON.parse(response));
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const contentDisposition = response.headers.get('Content-Disposition');

    if (contentDisposition) {
      const matches = contentDisposition.match(/filename="(.+)"/);
      if (matches && matches[1]) {
        fileName = matches[1];
      }
    }

    const blob = await response.blob();

    const link = document.createElement('a');
    const fileURL = URL.createObjectURL(blob);

    link.href = fileURL;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(fileURL);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};
export const importInventory = async (formData) => {
  return await importData('/inventory/import', formData);
};
export const importData = async (route, formData) => {
  try {
    const response = await apiClient.post(route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    showSuccessToast(response?.data?.message || '');

    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error.data;
  }
};

export const exportInventory = async (filters, fileName) => {
  return await exportData('/inventory/export', filters, fileName);
};
